export const useStoreEnvconfig = () => {
    const storeEnvconfig = (data) => {
        localStorage.setItem('tai_gtmid', data.gtmId || '');
        localStorage.setItem('tai_survicateWorkspace', data.survicateWorkspace);
        localStorage.setItem('tai_traceUrl', data.traceUrl || '');
        localStorage.setItem('tai_pipUrl', data.pipUrl || '');
        localStorage.setItem('tai_driveFaults', data.driveFaults);
    }
    return storeEnvconfig;
}